var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShortNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 12,
    viewBox: "0 0 43 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66903 2.72727V10H5.66051L1.96378 4.66619H1.89631V10H0.799006V2.72727H1.81463L5.51491 8.06818H5.58239V2.72727H6.66903ZM8.26971 10V2.72727H12.8294V3.67188H9.36701V5.88778H12.5914V6.82884H9.36701V9.0554H12.872V10H8.26971ZM15.0586 2.72727L16.7987 5.57173H16.8555L18.5955 2.72727H19.8668L17.6012 6.36364L19.881 10H18.6026L16.8555 7.1946H16.7987L15.0515 10H13.7731L16.092 6.36364L13.7873 2.72727H15.0586ZM20.5966 3.67188V2.72727H26.2251V3.67188H23.956V10H22.8622V3.67188H20.5966Z",
    fill: "#959CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3828 2.01172L37.9922 2.38281C37.8945 2.48047 37.8945 2.63672 37.9922 2.71484L41.0195 5.74219H34.3594C34.2227 5.74219 34.125 5.85938 34.125 5.97656V6.52344C34.125 6.66016 34.2227 6.75781 34.3594 6.75781H41.0195L37.9922 9.80469C37.8945 9.88281 37.8945 10.0391 37.9922 10.1367L38.3828 10.5078C38.4609 10.6055 38.6172 10.6055 38.7148 10.5078L42.7969 6.42578C42.8945 6.32812 42.8945 6.19141 42.7969 6.09375L38.7148 2.01172C38.6172 1.91406 38.4609 1.91406 38.3828 2.01172Z",
    fill: "#959CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortNext);
export default __webpack_public_path__ + "static/media/short-next.8b726934.svg";
export { ForwardRef as ReactComponent };